import { render } from "./PediatricWhatsApp.vue?vue&type=template&id=1843c604"
import script from "./PediatricWhatsApp.vue?vue&type=script&lang=js"
export * from "./PediatricWhatsApp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__